import styled from 'styled-components';
import { colors } from '../../globalStyles';

export const Link = styled.a({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-start',
  cursor: 'pointer',
  color: colors.green,
  '&:hover': {
    color: `${colors.darkGreen}!important`,
    opacity: 0.7,
  },
  '&:focus': {
    color: `${colors.darkGreen}!important`,
    opacity: 0.7,
  },
});

export const LinkBack = styled.a({
  color: colors.green,
  cursor: 'pointer',
  marginRight: '10px',
});

export const LinkBackHeader = styled.a({
  color: colors.white,
  marginRight: '15px',
  '&:hover': {
    color: `${colors.white}!important`,
    textDecoration: 'none',
  },
  '&:focus': {
    color: `${colors.white}!important`,
    textDecoration: 'none',
  },
});

export const LinkGray = styled.a({
  color: colors.gray,
});

export const LinkRight = styled.a({
  textAlign: 'right',
  cursor: 'pointer',
  color: colors.green,
  '&:hover': {
    color: `${colors.darkGreen}!important`,
    opacity: 0.7,
  },
  '&:focus': {
    color: `${colors.darkGreen}!important`,
    opacity: 0.7,
  },
});

export const LinkUpdate = styled(Link as any)({ marginTop: '5px' });
